/**
 * Outils techniques (diagnostics, tests d'intégration, démonstrations de composants) :
 * disponibles en développement, jamais sur le site public, sauf REACT_APP_SHOW_DEV_TOOLS=true.
 */
export const SHOW_DEV_TOOLS =
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_SHOW_DEV_TOOLS === 'true';
